/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { MethodMatch } from 'object-types';
import { IMethodMatch } from 'generated-types';
import { L10nService } from '@vmw/ngx-vip';
import * as l10n from './method-match-with-objects.l10n';
import './method-match-with-objects.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description MethodMatch component, used for plain objects/arrays.
 * @author alextsg
 */
@Component({
    selector: 'method-match-with-objects',
    templateUrl: './method-match-with-objects.component.html',
})
export class MethodMatchWithObjectsComponent {
    @Input()
    public config: IMethodMatch;

    /**
     * Match label passed to the MatchWrapperComponent.
     */
    @Input()
    public label: string;

    /**
     * Index of the match within the MatchAdder component.
     */
    @Input()
    public index = 0;

    /**
     * objectType passed to the MatchWrapperComponent.
     */
    @Input()
    public objectType: string;

    /**
     * fieldName passed to the MatchWrapperComponent.
     */
    @Input()
    public fieldName: string;

    /**
     * Disable any modifications to the fields.
     */
    @Input()
    public disabled = false;

    /**
     * EventEmitter for removing a match, passed to the MatchWrapperComponent.
     */
    @Output()
    public onRemoveMatch = new EventEmitter<void>();

    public readonly l10nKeys = l10nKeys;

    /**
     * Object Type to be used in template for tooltip.
     */
    public readonly methodMatchObjectType = MethodMatch;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Called to remove this match. Passed to the MatchWrapperComponent.
     */
    public removeMatch(): void {
        this.onRemoveMatch.emit();
    }
}
